import { render, staticRenderFns } from "./CreateVideoCall.vue?vue&type=template&id=41aa2550"
import script from "./CreateVideoCall.vue?vue&type=script&lang=js"
export * from "./CreateVideoCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports